<template>
    <div class="container consult">
      <div class="header card">
        <el-breadcrumb class="breadcrumb" separator="/">
          <el-breadcrumb-item>内容管理</el-breadcrumb-item>
          <el-breadcrumb-item>参考书</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="content">
          <div class="left">
            <h2 class="title">参考书</h2>
          </div>
          <div class="right">
            <el-button class="button" type="primary" @click="handleToCategory">分类管理</el-button>
            <el-button class="button" type="primary" @click="handleConsultCreate">添加参考书</el-button>
          </div>
        </div>
      </div>
      <div class="filters card">
        <el-form class="search-wrap" ref="searchForm" :inline="true" :model="query">
          <el-form-item label="参考书名称" prop="name">
            <el-input v-model="query.name" placeholder="输入参考书名称"></el-input>
          </el-form-item>
          <el-form-item label="发布人" prop="author">
            <el-input class="author" v-model="query.author" placeholder="输入发布人昵称/手机号"></el-input>
          </el-form-item>
          <el-form-item label="创建时间">
            <el-date-picker
              class="datetime"
              v-model="createDatetime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-select v-model="query.status" placeholder="请选择">
              <el-option
                v-for="item in filter.status"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="divider"></div>
        <div class="search-footer">
          <div class="filter-item">
            <span class="label">排序方式</span>
            <div class="values">
              <span :class="item.value == query.sort ? 'value-item active' : 'value-item'" v-for="item in filter.sorts" :key="item.value" @click="handleFilterChange(item.value, 'sort')">{{item.label}}</span>
            </div>
          </div>
          <div class="action-wrap">
            <el-button type="primary" @click="handleSearch">搜索</el-button>
            <el-button @click="handleFormReset('searchForm')">重置</el-button>
          </div>
        </div>
      </div>
      <div class="results card">
        <p class="title">查找结果</p>
        <div class="values">
          <ConsultCard class="exam-item" :content="item" @remove="handleConsultRemove" v-for="item in results" :key="item.id"/>
        </div>
        <div class="footer">
          <el-pagination
            background
            layout="total, prev, pager, next, sizes, jumper"
            :current-page="Number(query.pageIndex)"
            :page-sizes="[10, 20, 50, 100, 500]"
            :page-size="Number(query.pageSize)"
            :total="Number(pageTotal)"
            @size-change="handleSizeChange"
            @current-change="handlePageChange"
          ></el-pagination>
        </div>
      </div>
      <ConsultCreate :visible="createDialog" @close="createDialog = false" @submit="fetchConsultList"></ConsultCreate>
    </div>
</template>

<script>
import ConsultCard from '@/components/card/Consult'
import ConsultCreate from '@/components/dialog/consult/ConsultCreate'
import { consultList, consultDestroy } from '@/api/consult'

export default {
  components: {
    ConsultCard,
    ConsultCreate
  },
  data() {
    return {
      createDialog: false,
      query: {
        name: '',
        author: '',
        startTime: '',
        endTime: '',
        subject: '',
        type: '',
        status: '',
        sort: '1',
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize') ? Number(localStorage.getItem('pageSize')) : 10,
        isPaging: 1
      },
      createDatetime: '',
      pageTotal: 10,
      filter: {
        status: [
          {label: '全部', value: ''},
          {label: '已发布', value: '1'},
          {label: '未发布', value: '0'}
        ],
        sorts: [
          {label: '最新', value: '1'},
          {label: '最热', value: '2'}
        ]
      },
      results: []
    }
  },
  created() {
    this.parseQuery()
    this.fetchConsultList()
  },
  watch: {
    // 时间数据监听
    createDatetime(value) {
      if (value) {
        this.query.startTime = this.$moment(value[0]).valueOf()
        this.query.endTime = this.$moment(value[1]).valueOf()
      } else {
        this.query.startTime = ''
        this.query.endTime = ''
      }
    }
  },
  methods: {
    // 参考书列表请求
    fetchConsultList() {
      consultList(this.query).then(res => {
        this.results = res.list || []
        this.pageTotal = res.count
      })
      this.syncQuery()
    },
    // 检索条件变化
    handleFilterChange(value, type) {
      if (type === 'sort') {
        this.query.sort = value
      }
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchConsultList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchConsultList()
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, 'pageIndex', 1)
      this.fetchConsultList()
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields()
      // 手动处理
      this.createDatetime = null
      setTimeout(() => {
        this.fetchConsultList()
      }, 20)
    },
    // 分类管理
    handleToCategory() {
      this.$router.push(`/consult/category`)
    },
    // 参考书创建
    handleConsultCreate() {
      this.createDialog = true
    },
    // 参考书删除
    handleConsultRemove(examId) {
      // 二次确认删除
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning'
      }).then(() => {
        consultDestroy({id: examId}).then(res => {
          this.$message.success(`删除成功`)
          this.fetchConsultList()
        })
      }).catch(() => {})
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach(key => {
        this.query[key] = this.$route.query[key]
      })
      if (this.query.startTime && this.query.endTime) {
        this.createDatetime = [
          this.$moment(Number(this.query.startTime)),
          this.$moment(Number(this.query.endTime)),
        ]
      }
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(key => this.$route.query[key] != this.query[key])
      isSync && this.$router.replace({
        query: Object.assign({}, this.$route.query, this.query)
      })
    },
  }
}
</script>

<style scoped lang="less">
.consult {
  .card {
    position: relative;
    color: #303133;
    background-color: #FFF;
    border: 1px solid #EBEEF5;
    // box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {

    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }

      /deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner {
        color: #409eff;
        background: #ecf5ff;
        border-color: #b3d8ff;
        box-shadow: none!important;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .search-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }

    .filter-item {
      display: flex;

      .label {
        line-height: 32px;
        margin-right: 10px;
      }
      .values {
        display: flex;
        flex-wrap: wrap;
        flex: 1;
      }
      .value-item {
        height: 32px;
        line-height: 32px;
        border-radius: 4px;
        padding: 0 10px;
        margin-right: 5px;
        cursor: pointer;

        &.active {
          color: #fff;
          background: #409EFF;
        }

      }
    }

  }
  .results {
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
      display: flex;
      flex-wrap: wrap;
      margin-right: -15px;
    }
    .exam-item {
      margin-right: 15px;
      margin-bottom: 15px;
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
</style>
